export class ZeroDollarRfpSentStatusCodes {
  public static readonly Initiated = 'Initiated';
  public static readonly Accepted = 'Accepted';
  public static readonly Denied = 'Denied';
  public static readonly Expired = 'Expired';
}
